export const tagStatusColors = (type) => {
  let classColors;

  switch (type) {
    case "assigned":
      classColors = "custom-tag text-capitalize tag-offer rounded-pill";
      break;
    case "pending":
      classColors = "custom-tag text-capitalize tag-interview rounded-pill";
      break;
    case "accepted":
      classColors = "custom-tag text-capitalize tag-applied rounded-pill";
      break;
    case "rejected":
      classColors = "custom-tag text-capitalize tag-rejected rounded-pill";
      break;
    case "declined":
      classColors = "custom-tag text-capitalize tag-rejected rounded-pill";
      break;
    case "shortlisted":
      classColors = "custom-tag text-capitalize tag-green rounded-pill";
      break;
    case "completed":
      classColors = "custom-tag text-capitalize rounded-pill tag-interview"; // Assigning a default value for "completed" case
      break;
    default:
      classColors = "custom-tag text-capitalize tag-green rounded-pill";
      break;
  }

  return classColors;
};
